import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// Services
import { BsModalService } from 'ngx-bootstrap';
import { DataService } from '../../services/data.service';
import { AppService } from '../../services/app.service';
import { FreeTrialService } from '../../services/free-trial.service';

// Components
import { ContractTermsFreeTrialUpgradeModalComponent } from '../contract-terms-free-trial-upgrade-modal/contract-terms-free-trial-upgrade-modal.component';

// Model
import { School } from '../../model/school';

@Component({
	selector: 'app-free-trial-upgrade',
	templateUrl: './free-trial-upgrade.component.html',
	styles: [
		`
			.fa-check {
				color: green;
				font-size: small;
			}
		`,
		`
			.check-icon {
				color: blue;
				padding-right: 5px;
			}
		`,
		`
			.upgraded {
				font-size: larger
			}
		`
	]
})
export class FreeTrialUpgradeComponent implements OnInit {

	isLoading: boolean = false;
	isUpgrading: boolean = false;
	doneClicked: boolean = false;
	agreed: boolean = false;

	terms: string = "I understand I'm continuing my subscription program, and I authorize ChildPilot to charge my credit card account monthly for the price in effect each period until I cancel, beginning on the last day of my first billed month of use. I certify that the information above is correct and understand it will appear on my invoice."
	chosenPackage: string = "business";

	steps = [
		{done: false, name: 'choose'},
		{done: false, name: 'review'},
		{done: false, name: 'done'},
	];

	stepIndex: number = 0;

	get currentStep() {
		return this.steps[this.stepIndex]
	}

	constructor(
		private modalSvc: BsModalService,
		private dataSvc: DataService,
		private appSvc: AppService,
		private router: Router,
		private freeTrialSvc: FreeTrialService
	) { }

	async ngOnInit() {
		this.isLoading = true;
		
		// Get daycare guid from url
		let url = window.location.href
		let daycareAliasEncoded = this.dataSvc.getQueryStringParams(url, 'ID');
		let daycareAlias = atob(decodeURIComponent(daycareAliasEncoded));

		// Send to error page if no GUID
		if (daycareAlias == "") {
			this.isLoading = false;
			this.router.navigate(['error404']);
			return;
		}

		try {
			let daycare = await this.dataSvc.getDaycare(null,daycareAlias, false) as School;
			
			// Verify that the school is a childpilot lite client
			if (daycare && daycare.cpBillingPlan === 'lite' && !daycare.isDeleted) {
				this.dataSvc.daycare = daycare;
			}
			else {
				this.router.navigate(['error404']);
			}
			
		}
		catch(e) {
			this.router.navigate(['error404']);
			console.log(e);
		}

		this.isLoading = false;
	}

	btnNextStep() {
		this.activateNextStep()
	}

	// Increment step
	activateNextStep() {
		this.steps[this.stepIndex].done = true;
		this.stepIndex ++;
	}

	// decrement step
	activatePreviousStep() {
		this.steps[this.stepIndex-1].done = false;
		this.stepIndex --;
	}

	async btnComplete() {
		try {
			// Prevent someone from clicking the button multiple times
			if (this.isUpgrading)
				return;

			// Make sure agree checkbox is checked
			if (!this.agreed)
				return;

			this.isUpgrading = true;

			// Wait for firebase function that marks school as upgraded
			await this.freeTrialSvc.upgradeFreeTrial(this.dataSvc.daycare.name, this.dataSvc.daycare.inviteKey, this.chosenPackage, this.dataSvc.daycare.dynamics.accountID);

			// Send email confirmation
			this.freeTrialSvc.sendFreeTrialUpgradeConfirmation(this.dataSvc.daycare.name, this.dataSvc.daycare.inviteKey, this.chosenPackage);

			// Delete any scheduled emails that are to be sent to this school
			this.freeTrialSvc.deleteFollowUpEmails(this.dataSvc.daycare.name);

			this.isUpgrading = false;

			// Send to next step
			this.activateNextStep();
		}
		catch(e) {
			this.appSvc.showAlert('Failed to upgrade. Please try again.', 'danger-custom', true, 5000);
			this.isUpgrading = false;
			console.log(e);
		}
	}

    openContractTerms() {
        this.modalSvc.show(ContractTermsFreeTrialUpgradeModalComponent, { initialState: { cpBillingPlan: this.chosenPackage, schoolName: this.dataSvc.daycare.name }});
	}
	
	getActiveClass(packageName: string) {
		if (packageName === this.chosenPackage)
			return 'chosen';

		return '';
	}

	btnChangePlan() {
		this.activatePreviousStep()
	}

	get isMobile(): boolean {
		return window.innerWidth < 500;
	}

	// Returns bootstrap css
	getBtnWidth() {
		// Make buttons full width on mobile
		if (this.isMobile) {
			return 'w-100'
		}

		// otherwise 50%
		return 'w-50'
	}
}
